Bingo.NavigationHiding = {};

Bingo.NavigationHiding.init = function () {
    const calculateWidths = () => {
        let navigationWidth = 0;
        const otherDropdownWidth = $('.js-navigation-other').outerWidth(true);
        $('.js-navigation > a:not(.js-navigation-other)').each(function () {
            navigationWidth += $(this).outerWidth(true);
        });
        const availableWidth = $('.js-navigation > a:not(.js-navigation-other)').length > 1 ? $('.js-navigation').width() - otherDropdownWidth : $('.js-navigation').width();
        if (navigationWidth > availableWidth) {
            const lastItem = $('.js-navigation > a:not(.js-navigation-other-elements)').last();
            lastItem.attr('data-counted-width', lastItem.outerWidth(true)).removeClass('M-navigation__item');
            lastItem.prependTo($('.js-navigation-other-elements'));
            calculateWidths();
        } else {
            const firstMoreElement = $('.js-navigation-other-elements a').first();
            if (navigationWidth + firstMoreElement.data('counted-width') < availableWidth) {
                firstMoreElement.addClass('M-navigation__item').insertBefore($('.js-navigation-other'));
            }
        }
        if ($('.js-navigation-other-elements a').length > 0 && window.matchMedia('(min-width: 1200px)').matches) {
            $('.js-navigation-other').removeClass('-hidden');
        } else if ($('.js-navigation-other-elements a:not(.-hiddenOnMobile)').length > 0 && window.matchMedia('(max-width: 1199px)').matches) {
            $('.js-navigation-other').removeClass('-hidden');
        } else {
            $('.js-navigation-other').addClass('-hidden');
        }
        $('.js-navigation__item-hiddenAtStart').removeClass('-hiddenAtStart');
    };
    $(window).on('resize load', () => {
        calculateWidths();
    });
};
